import { ComponentFactoryResolver, ViewContainerRef, Component, OnInit } from '@angular/core';
import { SocketService } from '../shared/services/socket.service';
// import {PdfConvertorComponent} from '../pdf-convertor/pdf-convertor.component';
import {
    transition,
    trigger,
    query,
    style,
    animate,
    group,
    animateChild
} from '@angular/animations';
import { MatSnackBar, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ForceLogoutPopupComponent } from '../shared/components/force-logout-popup/force-logout-popup.component';
import { AuthService } from '../shared/services/auth/auth.service'; 


@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {

    constructor(private socketService:  SocketService,
                public dialog: MatDialog,
                private auth: AuthService) { }

    ngOnInit() {
        this.socketService.forceLogoutPopupObs.subscribe(data => {
            if (data) {
                const dialogRef = this.dialog.open(ForceLogoutPopupComponent, {
                    width: '500px',
                    data: {  }
                });
                dialogRef.afterClosed().subscribe(data => {
                    if (data['Proceed'] === true) {
                        this.auth.logout();
                    }
                });
            }
        })
    }

    removeSidebar() {
    }
    draweropen() {
    }

}
